export const inCompanyServicesArray = (state) => Object.values(state.list);
export const byCompanyServiceId = (state) => (id) => state.list[id];
